// Get SCSS variables via a special loader
// eslint-disable-next-line import/no-webpack-loader-syntax
module.exports = require('!!sass-to-js!@styles-variables')



// WEBPACK FOOTER //
// ./src/config/styles.js